import { useTranslation } from 'react-i18next'
import { cn } from '@/utils/cn'
import { categoryMeta } from '../meta'
import type { AnnouncementCategory } from '../types'

export function CategoryChip({
  category,
  className,
}: {
  category: AnnouncementCategory
  className?: string
}) {
  const { t } = useTranslation('announcements')
  const meta = categoryMeta[category]
  const Icon = meta.icon
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-2xs font-medium ring-1 ring-inset',
        meta.chip,
        className,
      )}
    >
      <Icon className="size-3" aria-hidden="true" />
      {t(meta.label)}
    </span>
  )
}

export function CategoryTile({
  category,
  className,
}: {
  category: AnnouncementCategory
  className?: string
}) {
  const meta = categoryMeta[category]
  const Icon = meta.icon
  return (
    <span
      className={cn('grid size-10 shrink-0 place-items-center rounded-xl', meta.tile, className)}
      aria-hidden="true"
    >
      <Icon className="size-5" />
    </span>
  )
}
